import { Superuser_UpdateTeamMembershipStatusMutation } from "@/graphql/generated/graphql";
import { useMutation } from "@apollo/client";

import { teamByIdQueryDocument, teamListForWorkspaceQueryDocument } from "../../api/team.gql";
import { teamMembershipListQueryDocument } from "../../api/team-membership.gql";

import { superuser_teamListForWorkspaceQueryDocument } from "./team.gql";
import { superuser_updateTeamMembershipStatusMutationDocument } from "./team-membership.gql";

export type UpdatedTeamMembership =
  Superuser_UpdateTeamMembershipStatusMutation["superuser_updateTeamMembershipStatus"];

export interface UseUpdateTeamMembershipStatusProps {
  team: {
    id: string;
    workspaceId: string;
  };
  onCompleted?: (updatedTeamMembership: UpdatedTeamMembership) => void;
  onError?: (e: Error) => void;
}

export const useTeamMembershipUpdateStatus = ({
  onCompleted,
  onError,
  ...props
}: UseUpdateTeamMembershipStatusProps) => {
  const [updateStatus, queryResult] = useMutation(superuser_updateTeamMembershipStatusMutationDocument, {
    onCompleted: onUpdateCompleted,
    onError: onUpdateError,
    refetchQueries: [
      {
        query: teamMembershipListQueryDocument,
        variables: {
          input: props.team.id,
        },
      },
      {
        query: teamByIdQueryDocument,
        variables: { input: props.team.id },
      },
      {
        query: teamListForWorkspaceQueryDocument,
        variables: { input: props.team.workspaceId },
      },
      {
        query: superuser_teamListForWorkspaceQueryDocument,
        variables: { input: props.team.workspaceId },
      },
    ],
  });

  function onUpdateCompleted(data: Superuser_UpdateTeamMembershipStatusMutation) {
    if (onCompleted) {
      onCompleted(data.superuser_updateTeamMembershipStatus);
    }
  }
  function onUpdateError(e: Error) {
    if (onError) {
      onError(e);
    }
  }

  return {
    queryResult,
    updateStatus,
    loading: queryResult.loading,
    error: queryResult.error,
  };
};
